"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const SvgIcon_1 = tslib_1.__importDefault(require("@mui/material/SvgIcon"));
const MenuNFCertChat = (
// Allows the callee to override the default values and pass any additional prop of SvgIcon. See https://material-ui.com/api/svg-icon/
{ titleAccess, fontSize = "small", ...rest }, forwardedRef) => (react_1.default.createElement(SvgIcon_1.default, { ...{ titleAccess, fontSize, ...rest, ref: forwardedRef } },
    react_1.default.createElement("path", { d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z" })));
const IconWithRef = react_1.default.forwardRef(MenuNFCertChat);
if (process.env.NODE_ENV !== "production") {
    // @ts-ignore: Expose property used for testing
    IconWithRef.Naked = MenuNFCertChat;
}
exports.default = IconWithRef;
